module.exports = __webpack_public_path__ + "static/media/ico_aguardando.fed45055.svg";